import { render, staticRenderFns } from "./_base-expansion.vue?vue&type=template&id=edfc57fc&scoped=true&"
import script from "./_base-expansion.vue?vue&type=script&lang=js&"
export * from "./_base-expansion.vue?vue&type=script&lang=js&"
import style0 from "./_base-expansion.vue?vue&type=style&index=0&id=edfc57fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfc57fc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edfc57fc')) {
      api.createRecord('edfc57fc', component.options)
    } else {
      api.reload('edfc57fc', component.options)
    }
    module.hot.accept("./_base-expansion.vue?vue&type=template&id=edfc57fc&scoped=true&", function () {
      api.rerender('edfc57fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-expansion.vue"
export default component.exports